import { PatientRegisterType } from '../enums';

export class PatientRegisterTypeLookup {

    static getLookup(): any[] {
        return [
            { labelKey: 'Patient', value: PatientRegisterType.Patient },
            { labelKey: 'Early Detection', value: PatientRegisterType.EarlyDetection },
            { labelKey: 'Unknown Patient', value: PatientRegisterType.UnknownPatient },
            { labelKey: 'Hospital Staff', value: PatientRegisterType.HospitalStaff },
            { labelKey: 'Head Of Family', value: PatientRegisterType.HeadOfFamily }
        ];
    }
}
